import { doc, setDoc, getDoc, getFirestore, collection, serverTimestamp, query, where, orderBy, getDocs, limit, updateDoc, arrayUnion} from "firebase/firestore"; 
import { getAppSingleton } from "./InitFirebase";
import { auth } from "./InitFirebase";

const app = getAppSingleton();
// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);


export async function saveUserSubmission(problemID, userID, IDEText, LanguageID, passedProblem){
    const submissionsCollectionRef = collection(db, "submissions");
    const singleSubmssionDoc = doc(submissionsCollectionRef);
    await setDoc(singleSubmssionDoc,
        {
            userID : userID,
            problemID : problemID,
            LanguageID : LanguageID,
            IDEText : IDEText,
            submissionTime : serverTimestamp(),
            passedProblem : passedProblem
        }
    )
}


export async function getUsersSubmissionsForProblem(problemID, currUser){
    const q = query(
        collection(db, "submissions"),
        where("problemID", "==", problemID),
        where("userID", "==", currUser),
        orderBy("submissionTime", "desc"),
        limit(100)
      );
    const querySnapshot = await getDocs(q);
    return querySnapshot;
}


export async function addProblemToSolved(problemID) {
    const user = auth.currentUser;
    if (!user) return;
  
    const refToUser = doc(db, "users", user.uid); // Set document id to bet user.uid
  
    await setDoc(refToUser, {
        solvedProblems: arrayUnion(problemID)
    }, {merge: true}); // This could be a problem? If merge got set to false it would delete other data, like a little hack to get around rate limiting
}


export async function getSolvedProblems() {
    const user = auth.currentUser;
    if (!user) return [];

    const userRef = doc(db, "users", user.uid); 
    const userDoc = await getDoc(userRef);
  
    if (userDoc.exists()) {
      return userDoc.data().solvedProblems || [];
    }
    return [];
}



export async function accountCreation() {
    
    const user = auth.currentUser;
    if(!user) throw new Error("User should be authenticated before calling accountCreation()");

    const userRef = doc(db, "users", user.uid);
    const userDoc = await getDoc(userRef);

    if(!userDoc.exists()){
        const currentMonth = new Date().getMonth() + 1; 
        console.log("SETTING DOC")
        try{
            await setDoc(userRef, {
                monthBeingTracked: currentMonth,
                submissionsThisMonth: 0
            })
        }catch(err){
            console.log("[DB ERROR], accountCreation() failed.")
        }
    }
}










